// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"66":"53c1cc09","78":"66d47cbb","198":"215a30af","261":"83d2ae33","747":"267d5019"}[chunkId] + ".chunk.js";
};